<template lang="pug">
.container-signin
  auth-card
    .col-group(style="margin:0 auto")
      gb-input(
        label="メールアドレス",
        v-model="userEmail"
      )
      gb-input(
        label="パスワード"
        type="password"
        v-model="userPassword"
      )
    div.block(style="margin:0 auto")
      .col-group
        gb-button.primary(
          @clicked="signIn"
          :isLoading="isButtonLoading"
        ) ログイン
      .col-group(style="margin-top:20px;")
        .to-signup(@click="toSignUp") アカウントをお持ちでない方
</template>

<script>
import util from '@/api/util'
import LocalDataUtil from '@/util/LocalDataUtil.js'

import AuthCard from '@/components/organisms/AuthCard.vue'
import GbButton from '@/components/atoms/GbButton.vue'
import GbInput from '@/components/atoms/GbInput.vue'

export default {
  components: {
    AuthCard,
    GbButton,
    GbInput
  },
  data () {
    return {
      userEmail: null,
      userPassword: null,
      isButtonLoading: false
    }
  },
  created () {
    util.createMethod('COG', 'checkSessionExpired', null)
      .then(response => {
        if (!response) this.$router.push({ name: 'SchoolList' })
      })
  },
  methods: {
    toSignUp () {
      this.$router.push({ name: 'SignUp' })
    },
    async signIn () {
      this.isButtonLoading = true
      if (this.userEmail === '' || this.userEmail === null) {
        this.$swal.fire({
          text: `メールアドレスを入力してください`
        }).then(() => {
          this.isButtonLoading = false
        })
        return
      } else if (this.userPassword === '' || this.userPassword === null) {
        this.$swal.fire({
          text: `パスワードを入力してください`
        }).then(() => {
          this.isButtonLoading = false
        })
        return
      }
      try {
        const CCS_REQUEST_VALUE = {
          id: 'adminuser',
          pass: 'admin1234567890',
          staticid: 'admin'
        }
        const CCSAuthData = (await util.createMethod('CCS', 'ccsSignIn', CCS_REQUEST_VALUE))
        LocalDataUtil.setCcsSession(CCSAuthData.data.session)
        try {
          const COG_REQUEST_VALUE = {
            username: this.userEmail,
            password: this.userPassword
          }
          const COGAuthData = (await util.createMethod('COG', 'signIn', COG_REQUEST_VALUE))
          LocalDataUtil.setSub(COGAuthData.attributes.sub)
          const COGSessionData = (await util.createMethod('COG', 'currentSession', {}))
          LocalDataUtil.setSessionData(COGSessionData)
          this.isButtonLoading = false
          this.$router.push({ name: 'SchoolList' })
        } catch (error) {
          this.$swal.fire({
            text: `メールアドレス、またはパスワードが違います`
          }).then(() => {
            this.isButtonLoading = false
          })
        }
      } catch (error) {
        this.$swal.fire({
          text: `メールアドレス、またはパスワードが違います`
        }).then(() => {
          this.isButtonLoading = false
        })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../stylus/main.styl'
.to-signup
  color $color-secondary
  font-size 10px
  text-align center
  cursor pointer
.container-signin
  width 100vw
  height 100vh
  display flex
  justify-content center
  align-items center
.col-group
  display flex
  flex-direction column
.block
  display block
  margin 0 auto
</style>



// WEBPACK FOOTER //
// src/views/SignIn.vue